
export default {
	request: {
		baseUrl: "", // 请求链接
		header: {
			'content-type': 'application/json'
		},
		timeout: 60000,
		dataType: "json",
		responseType: "text"
	},
	tabBarList: {
		defaultHome: '',
		list: []
	}
}
